import { PALETTE } from '../../common/styles/palette';
export const styles = (theme: any) => {
    return {
        root: {
            marginLeft: '10px',
            marginTop: '10px',
            marginBottom: '10px',
            paddingRight: '10px',
        },
        label: {
            trasnform: 'translate(0, 15px) scale(1)'
        },
        clearIcon: {
            width: '12px',
            height: '12px',
            color: PALETTE.UI.InputText.ClearIconColor,
            fill: PALETTE.UI.InputText.ClearIconColor
        },
        text: {
            color: PALETTE.UI.InputText.TextColor,
            padding: 0
        }
    }
}
